import React,{useContext,useState} from 'react'
import { useForm,FormProvider } from 'react-hook-form';
import { SkywatchDialog } from '../../components/PopUps/SkywatchDialog'
import { Grid ,Typography} from "@material-ui/core"
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { ControlledTextField } from "../Core/Form/ControlledFields";
import { OrangeButton } from "../../components/Core/Buttons/OrangeButton"
import { QuoteContextStore } from '../../context/QuoteContext/QuoteContext';
import { SessionContextStore } from "../../context/SessionContext/SessionContext";
import {LoadingContextStore} from "../../context/LoadingContext/LoadingContext";
import { NNUMBER_REGEX } from "../../Constants";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';


export const nnumberSchema = yup
.object()
  .shape({
    n_number: yup.string().typeError('Required').required('Required').matches(NNUMBER_REGEX,"Invalid NNumber")
})
.required();

export const UnknownNNumberPopup = ({ message, title, confirmButtonText, isOpen, setIsOpen }) => {
    const { awaitWithLoading } = useContext(LoadingContextStore);
    const { quoteId } = useParams();
    const { coverages: { selected }, aircrafts, finishUnknownNNumberPopup, loadQuote, start_date, finishSummary } = useContext(QuoteContextStore);
    const form = useForm({mode: 'onSubmit', defaultValues: {n_number:""}, resolver: yupResolver(nnumberSchema)});

    const onSubmit = async (data) => {
        const response = await awaitWithLoading(finishUnknownNNumberPopup(quoteId, Object.keys(aircrafts)[0], data.n_number,{...selected}, start_date));
        if(response) {
            const parsedStartDate = dayjs(data.start_date).format();
            await finishSummary({quoteId, start_date: parsedStartDate});
            await awaitWithLoading(loadQuote())
            setIsOpen(false)
        }
    }

    return (
        <SkywatchDialog 
            open={isOpen}
            closeDialog={() => setIsOpen(false)}
            maxWidth={'xs'}>
            <Grid container justifyContent="center">
                    <Typography variant="h2" className="bold blue margin-bottom-basic margin-top-basic">{title}</Typography>
                </Grid>
                <Grid container justifyContent="center">
                    <Typography variant="body3">{message}</Typography>
                </Grid>
                <form autoComplete="off" novalidate onSubmit={form.handleSubmit(onSubmit)} className="margin-top-medium margin-bottom-basic">
                    <FormProvider {...form}>
                        <ControlledTextField fullWidth={true} name="n_number" className="margin-top-8" placeholder="Registration number" isIconAtStart IconComponent={() => <span className="grey n-number">N</span>}/>
                    </FormProvider>
                    <Grid container justifyContent="center">
                    <OrangeButton type="submit" className="margin-top-basic" >{confirmButtonText}</OrangeButton>
                    </Grid> 
                </form>
        </SkywatchDialog>
    );
}